import Cookies from "js-cookie";
import { useEffect } from "react";

export const useUTM = () => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const utmCampaign = searchParams.get("utm_campaign");
    let utmSource = searchParams.get("utm_source");
    const utmMedium = searchParams.get("utm_medium");
    const utmTerm = searchParams.get("utm_term");
    const utmContent = searchParams.get("utm_content");
    const journeyFromQuery = searchParams.get("journey");
    const spocket_utm = Cookies.get("spocket_utm");

    if (!utmSource) {
      const referrer = document.referrer;

      if (referrer) {
        try {
          const url = new URL(referrer);
          const hostname = url.hostname;

          const parts = hostname.split(".");
          utmSource = parts.length > 2 ? parts[parts.length - 2] : parts[0];
        } catch (e) {
          console.error("Failed to parse referrer URL:", e);
        }
      }
    }

    if (
      !utmCampaign &&
      !utmSource &&
      !utmMedium &&
      !utmTerm &&
      !spocket_utm &&
      !utmContent &&
      !journeyFromQuery
    )
      return;

    localStorage.setItem("utm_campaign", utmCampaign || "");
    localStorage.setItem("utm_source", utmSource || "");
    localStorage.setItem("utm_medium", utmMedium || "");
    localStorage.setItem("utm_term", utmTerm || "");
    localStorage.setItem("utm_content", utmContent || "");
    localStorage.setItem("spocket_utm", spocket_utm || "");

    // persist journey: prefer explicit query param, fallback to any existing landing_page markers
    const journeyFromStorage = localStorage.getItem("landing_page_signup");
    const journey = journeyFromQuery || journeyFromStorage || "";
    if (journey) {
      localStorage.setItem("utm_journey", journey);
    }
  }, []);

  const getUTM = key => {
    const value = localStorage.getItem(key);
    if (!value) return null;
    return value;
  };

  const utms = {
    utm_campaign: getUTM("utm_campaign"),
    utm_source: getUTM("utm_source"),
    utm_medium: getUTM("utm_medium"),
    utm_term: getUTM("utm_term"),
    utm_content: getUTM("utm_content"),
    spocket_utm: getUTM("spocket_utm"),
    journey: getUTM("utm_journey")
  };

  return utms;
};
